import React, { FC } from 'react';
import { StyleSheet, View } from 'react-native';
import LinearGradient from 'react-native-linear-gradient';

import { lowerDisplayLineTestIDs, Theme } from '@constants';

const getMarkerLeftOffset = (severity: number = 0) => {
  switch (severity) {
    case 0:
      return -Theme.px(14);
    case 1:
      return Theme.px(112.5) - Theme.px(14);
    case 2:
      return Theme.px(225) - Theme.px(14);
    case 3:
      return Theme.px(337.5) - Theme.px(14);
    case 4:
      return Theme.px(450) - Theme.px(14);
    default:
      return -Theme.px(14);
  }
};

const { first, second, third, fourth, fifth, sixth } = Theme.gradients.ldlPollenScale;

type LDLPollenScaleProps = {
  severity?: number;
};

export const LDLPollenScale: FC<LDLPollenScaleProps> = ({ severity = 0 }) => {
  const markerLeftOffset = getMarkerLeftOffset(severity);

  return (
    <LinearGradient
      colors={[first, second, third, fourth, fifth, sixth]}
      end={{ x: 1, y: 0 }}
      start={{ x: 0, y: 0 }}
      style={styles.pollenScaleLinearGradient}
      testID={lowerDisplayLineTestIDs.pollen.pollenScale}
    >
      <View style={[styles.pollenScaleMarker, { left: markerLeftOffset }]} />
    </LinearGradient>
  );
};

const styles = StyleSheet.create({
  pollenScaleLinearGradient: {
    height: Theme.px(12),
    justifyContent: 'center',
    width: Theme.px(450),
  },
  pollenScaleMarker: {
    backgroundColor: Theme.white,
    borderColor: Theme.blackPearlBlack,
    borderRadius: Theme.px(14),
    borderWidth: Theme.px(4),
    height: Theme.px(28),
    width: Theme.px(28),
  },
});
